import gql from 'graphql-tag'
import * as React from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '../../api/graphql'
import { storyFragment } from '../../graphql/fragments'
import { useRedirect } from '../../hooks'
import useRecordLookup from '../../hooks/useRecordLookup'
import Routes, { CommunitySlugRouteParams } from '../../startup/routes'
import Loading from '../components/misc/Loading'
import { RecordLoadFailed, RecordNotFound } from '../components/misc/RecordNotFound'
import StoryView from '../components/stories/StoryView'

const StoryViewQuery = gql`
  ${storyFragment}
  query StoryView($storySlug: String!) {
    story(slug: $storySlug) {
      ...storyFragment
      content
    }
  }
`

const StoryViewContainer: React.FC = () => {
  const { idOrName, id: storySlug } = useParams<CommunitySlugRouteParams & { id: string }>()

  const { loading, error, data: { story: foundStory = null } = {} } = useQuery(StoryViewQuery, {
    variables: { storySlug },
    skip: !storySlug,
    // The page says "Something went wrong" itself (CVL-145)
    context: { silentErrors: true },
  })
  // Under a town, a story that belongs to no town is not found (CVL-138).
  const story = idOrName && foundStory && !foundStory.communities?.length ? null : foundStory

  // A story opened by its number (or a differently written name) moves to its name in the same town.
  useRedirect(story && story.slug !== storySlug && Routes.story(story, idOrName))

  const lookup = useRecordLookup({ loading, error, record: story })
  if (lookup === 'loading') return <Loading className="isCentered isDark" />
  if (lookup === 'failed') return <RecordLoadFailed />
  if (lookup === 'notFound' || !story) return <RecordNotFound kind="story" backTo={Routes.stories(idOrName)} backLabel="Back to Stories" />
  return <StoryView story={story} />
}

export default StoryViewContainer
